$(document).ready(function(){

  function slickCize(element,items,row,arrow,dot,breakpoint) {
    if (arrow == 'true') {
      arrow = true
    } else {
      arrow = false
    }
    if (dot == 'true') {
      dot = true
    } else {
      dot = false
    }
    if (row == 'true') {
      row = true
    } else {
      row = false
    }
    if ($(window).width() >= breakpoint) {
      if (element.hasClass('slick-slider')) {
        element.slick('unslick')
      }
      element.css('flex-direction','')
      if (row) {
        element.slick({
          rows:2,
          slidesPerRow: items,
          slidesToScroll: 1,
          infinite: false,
          dots: dot,
          arrows: arrow,
          prevArrow: '<button type="button" class="carousel-prev"><span class="fa fa-angle-left"></span></button>',
          nextArrow: '<button type="button" class="carousel-next"><span class="fa fa-angle-right"></span></button>'
        })
      } else {
        element.slick({
          slidesToShow: items,
          slidesToScroll: items,
          infinite: false,
          dots: dot,
          arrows: arrow,
          prevArrow: '<button type="button" class="carousel-prev"><span class="fa fa-angle-left"></span></button>',
          nextArrow: '<button type="button" class="carousel-next"><span class="fa fa-angle-right"></span></button>'
        })
      }
    }
    $(window).resize(function(){
      if ($(window).width() >= breakpoint) {
        if (element.hasClass('slick-slider')) {
          element.slick('unslick')
        }
        element.css('flex-direction','')
        if (row) {
          element.slick({
            rows:2,
            slidesPerRow: items,
            slidesToScroll: 1,
            infinite: false,
            dots: dot,
            arrows: arrow,
            prevArrow: '<button type="button" class="carousel-prev"><span class="fa fa-angle-left"></span></button>',
            nextArrow: '<button type="button" class="carousel-next"><span class="fa fa-angle-right"></span></button>'
          })
        } else {
          element.slick({
            slidesToShow: items,
            slidesToScroll: items,
            infinite: false,
            dots: dot,
            arrows: arrow,
            prevArrow: '<button type="button" class="carousel-prev"><span class="fa fa-angle-left"></span></button>',
            nextArrow: '<button type="button" class="carousel-next"><span class="fa fa-angle-right"></span></button>'
          })
        }
      }
    })
  }

  function slickCizeAsync(elementAsync,element,items,breakpoint,style) {
    if (style == 'true') {
      style = true
    } else {
      style = false
    }
    if ($(window).width() >= breakpoint) {
      if (element.hasClass('slick-slider')) {
        element.slick('unslick')
      }
      if (element.children().length <= items) {
        items = element.children().length - 1
      }
      element.slick({
        slidesToShow: items,
        slidesToScroll: 1,
        asNavFor: elementAsync,
        focusOnSelect: true,
        vertical: style,
        verticalSwiping: style,
        arrows: false,
      });
    }
    $(window).resize(function(){
      if ($(window).width() >= breakpoint) {
        if (element.hasClass('slick-slider')) {
          element.slick('unslick')
        }
        if (element.children().length <= items) {
          items = element.children().length - 1
        }
        element.slick({
          slidesToShow: items,
          slidesToScroll: 1,
          asNavFor: elementAsync,
          focusOnSelect: true,
          vertical: style,
          verticalSwiping: style,
          arrows: false,
        });
      }
    })
  }

  function slideShowV1() {
    $('.js-slideshow-v1').slick({
      dots: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      infinite: true,
      adaptiveHeight: true
    }); 
  }

  function productDetailSlide(){
    var check = $('.js-slide-main').attr('data-slide')
    if (check == 'true' ) {
      $('.js-slide-main').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        fade: true,
        asNavFor: '.js-slide-item'
      });
      slickCizeAsync($('.js-slide-main'),$('.js-slide-item'),3,0,'false')
      slickCizeAsync($('.js-slide-main'),$('.js-slide-item'),4,576,'false')
      slickCizeAsync($('.js-slide-main'),$('.js-slide-item'),3,768,'true')
      slickCizeAsync($('.js-slide-main'),$('.js-slide-item'),4,1400,'true')
    }
  }
  function productDetailSlideBT() {
    var check = $('.js-slide-main-bt').attr('data-slide')
    if (check == 'true' ) {
      $('.js-slide-main-bt').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        fade: true,
        asNavFor: '.js-slide-item-bt',
        adaptiveHeight: true
      });
      slickCizeAsync($('.js-slide-main-bt'),$('.js-slide-item-bt'),3,0,'false')
      slickCizeAsync($('.js-slide-main-bt'),$('.js-slide-item-bt'),4,576,'false')
    }
  }
  function productDetailSingleSlide() {
    $('.js-single-slide').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      fade: true,
      adaptiveHeight: true,
      prevArrow: '<button type="button" class="carousel-prev border-image"><span class="flaticon-left-arrow-1"></span></button>',
      nextArrow: '<button type="button" class="carousel-next border-image"><span class="flaticon-right-arrow-1"></span></button>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false
          }
        }
      ]
    });
  }

  function relatedSlick(){
    slickCize($('.js_relate_product'),1,'false','true','false',0)
    slickCize($('.js_relate_product'),2,'false','true','false',576)
    slickCize($('.js_relate_product'),3,'false','true','false',768)
    slickCize($('.js_relate_product'),4,'false','true','false',992)
  }

  function btnSidebar() {

    $('.js-btn-sidebar').on('click',function(){
      $('.toggle-sidebar #toggle-sidebar').toggleClass('active')
      $(this).children().toggleClass('flaticon-close');
      $('.js-overlay-filter-sidebar').toggleClass('active');    
    });
    $('.js-overlay-filter-sidebar').on('click',function(){
      $('.toggle-sidebar #toggle-sidebar').toggleClass('active')
      $('.js-btn-sidebar').children().toggleClass('flaticon-close');
      $('.js-overlay-filter-sidebar').toggleClass('active'); 
    });
  }
  function productCollectionSlide(){
    $('.js-tab-collection').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      infinite: true,
      arrows: false,
      variableWidth: true
    });
  }

  function blogCarousel() {
    var arrow = $('.js-blog-v1').attr('data-arrow')
    var dot = $('.js-blog-v1').attr('data-dot')
    slickCize($('.js-blog-v1'),1,'false','false','true',0)
    slickCize($('.js-blog-v1'),2,'false','false','true',768)
    slickCize($('.js-blog-v1'),3,'false',arrow,dot,992)
  }


  function productCarousel() {
    $('.js-product').each(function(){
      var $this = $(this)
      var perRow = parseInt($this.attr('data-product'));
      var arrow = $this.attr('data-arrows');
      var dot = $this.attr('data-dots');
      var row = $this.attr('data-row')
      slickCize($this,1,'false','true','false',0)
      slickCize($this,2,'false','true','false',480)
      slickCize($this,3,'false','true','false',768)
      slickCize($this,4,row,'true','true',992)
      slickCize($this,perRow,row,arrow,dot,1400)
    })
  }

  function clickTab() {
    var old, link
    $('a[data-style="tab"]').each(function(){
      $(this).on('click',function(e){
        old = $(this).parent().parent().find('.active')
        link = old.attr('href')
        old.removeClass('active')
        $(''+link).removeClass('active')
        $(this).addClass('active')
        $(''+$(this).attr('href')).addClass('active')
        e.preventDefault()
      })
    })
  }


  function productCollection() {
    $('.js-product-collection').each(function(){
      var $this = $(this)
      var perRow = parseInt($this.attr('data-product'));
      var arrow = $this.attr('data-arrows');
      var dot = $this.attr('data-dots');
      slickCize($this,1,'false','false','true',0)
      slickCize($this,2,'false','false','true',480)
      slickCize($this,perRow,'false',arrow,dot,1400)
    })
  }


  function testimonialAndBlog() {
    $('.js-testimonial-v1').slick({
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      prevArrow: '<button class="testimonial-blog-arrow arrow-prev testimonial-prev"><i class="fa fa-angle-left"></i></button>',
      nextArrow: '<button class="testimonial-blog-arrow arrow-next testimonial-next"><i class="fa fa-angle-right"></i></button>',
      dots: false,
    });
    slickCize($('.js-testimonial-v1'),1,'false',true,false,576)
    slickCize($('.js-testimonial-v1'),2,'false',true,false,768)
  }

  function testimonialV1() {
    slickCize($('.js-testimonial-v1-slide'),1,'false','true','true',0)
  }

  function testimonialV2() {
    $('.js-testimonial-v2-slide').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      vertical: false,
      infinite: false,
      arrows: false,
      dots: true,
    });
  }

  function categoryV2() {
    slickCize($('.js-category-v2'),2,'false','false','true',0)
    slickCize($('.js-category-v2'),3,'false','false','true',480)
    slickCize($('.js-category-v2'),4,'false','false','true',768)
    slickCize($('.js-category-v2'),5,'false','false','true',992)
    slickCize($('.js-category-v2'),6,'false','false','true',1200)
  }

  function verticalMenu() {
    $('.js-open-vertical-menu').on('click',function(){
      $('.vertical').addClass('active')
      $('.js-menu-popup').removeClass('d-none')
    })
    $('.js-menu-popup').on('click',function(){
      $(this).addClass('d-none')
      $('.vertical').removeClass('active')
    })
  }

  function ESC() {
    $(document).keyup(function(e) {
      var key = e.keyCode
      if (key == 27) {
        $('.bg-popup').click();
        $('.js-menu-popup').click();
      }
    });
  }

  function slideShowV3() {

    $('.js-slideshow-v3').slick({
      dots: true,
      arrows: false,
      autoplay: false,
      autoplaySpeed: 5000,
      fade: true,
      infinite: true,
      adaptiveHeight: true,
    });
  }

  function slideShowV2() {
    $('.js-slide-image-v2').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      fade: true,
      autoplay: false,
      autoplaySpeed: 5000,
      asNavFor: '.js-slide-info-v2',
    });
    $('.js-slide-info-v2').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      asNavFor: '.js-slide-image-v2',
    });
    if ($(window).width() > 1199) {
      $('.js-slide-info-v2').parent().on('mouseenter',function() {
        $('.js-slide-info-v2').css('transition','')
      })
      $('.js-slide-info-v2').parent().on('mousemove',function(event){
        var left = event.clientX;
        var top = event.clientY
        $('.js-slide-info-v2').each(function(){
          var top1 = $('.js-slide-info-v2').parent().position().top 
          var left1 = $('.js-slide-info-v2').parent().position().left 
          $('.js-slide-info-v2').css("transform",function(){
            var x = -(left-left1)/10
            var y = -(top-top1)/10
            return 'translate('+x+'px,'+y+'px)'
          })
        })
      })
      $('.js-slide-info-v2').parent().on('mouseleave',function(){
        $('.js-slide-info-v2').css({'transform':'none','transition':'.6s'})
      })
    }
  }


  function slideShowV4() {
    $('.js-slide-v4').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 5000,
      centerMode: true,
      centerPadding: '0px',
      focusOnSelect: true,
      prevArrow: '<button type="button" class="carousel-prev"><span class="fa fa-angle-left"></span></button>',
      nextArrow: '<button type="button" class="carousel-next"><span class="fa fa-angle-right"></span></button>'
    });
  }

  function bannerSlide(){
    var dot = $('.js-banner-slide').attr('dot')
    if (dot == 'true') {
      dot = true
    } else {
      dot = false
    }
    $('.js-banner-slide').slick({
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: dot
    });
  }

  function slideshowBanner() {
    $('.js-slideshow-banner').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      arrows: true,
      dots: false,
      prevArrow: '<button type="button" class="slideshow-arrow slick-slide-prev"><i class="fa fa-angle-down"></i></button>',
      nextArrow: '<button type="button" class="slideshow-arrow slick-slide-next"><i class="fa fa-angle-up"></i></button>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            arrows: false
          }
        }
      ]
    });



    $('.js-slideshow-banner .slideshow-content').eq(0).addClass('active')
    $('.js-slideshow-banner .slider-img').eq(0).addClass('active')
    $('.js-slideshow-banner .extra').eq(0).addClass('active')
    $('.js-slideshow-banner').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      var mySlideNumber = nextSlide;
      var prev = currentSlide
      $('.js-slideshow-banner .slideshow-content').eq(mySlideNumber).addClass('active');
      $('.js-slideshow-banner .slider-img').eq(mySlideNumber).addClass('active');
      $('.js-slideshow-banner .extra').eq(mySlideNumber).addClass('active');
      $('.js-slideshow-banner .slideshow-content').eq(prev).removeClass('active');
      $('.js-slideshow-banner .slider-img').eq(prev).removeClass('active');
      $('.js-slideshow-banner .extra').eq(prev).removeClass('active');
    })


    if ($(window).width() > 1199) {
      $('.slideshow').on('mouseenter',function() {
        $('.js-effect-slide-banner').find('img').css('transition','')
      })
      $('.slideshow').on('mousemove',function(event){
        var left = event.clientX;
        var top = event.clientY
        $('.js-effect-slide-banner').each(function(){
          var top1 = $('.js-effect-slide-banner').position().top 
          var left1 = $('.js-effect-slide-banner').position().left 
          $('.js-effect-slide-banner').find('img').css("transform",function(){
            var x = -(left-left1)/10
            var y = -(top-top1)/10
            return 'translate('+x+'px,'+y+'px)'
          })
        })
      })
      $('.slideshow').on('mouseleave',function(){
        $('.js-effect-slide-banner').find('img').css({'transform':'none','transition':'.6s'})
      })
    }
  }

  function menuMobile() {  
    $('.js-open-mobile-menu').click(function(){
      $('body').toggleClass('active')
      $('.bg-mobile-menu').toggleClass('active')
    })
    $('.bg-mobile-menu').on('click',function(){
      $('body').removeClass('active')
      $(this).removeClass('active')
      $('.tab-menu-mobile ul').removeClass('active, .active2')
      $('.tab-menu-1').addClass('active')
    })
    $('.js-link-click').each(function(){
      $(this).on('click',function(e){
        e.preventDefault()
        var id = $(this).attr('data-click')
        $(this).parents('.active').addClass('active2')
        var link = $('[data-open="'+id+'"]')
        link.addClass('active')
      })
    })
    $('.js-header-mobile-menu').each(function(){
      $(this).on('click',function(){
        var $link = $('.tab-menu-mobile').find('.active2').eq(-1)
        $(this).parent().removeClass('active')
        $link.removeClass('active2')
      })
    })
  }

  function hdFixed() {
    var start = $('header').position().top
    var absolute = true
    var topbar = 0
    if ($('.topbar').length > 0 ) {
      topbar = $('.topbar').outerHeight()
    }
    if (!$('.js-hd-fix').hasClass('hd-absolute') && $(window).width() > 1199 ) {
      $('.js-hd-fix').parent().css('height',$('.js-hd-fix').outerHeight()+topbar+'px')
    } else {
      $('.js-hd-fix').parent().css('height','')
    }
    $(window).resize(function(){
      if (!$('.js-hd-fix').hasClass('hd-absolute') && $(window).width() > 1199) {
        $('.js-hd-fix').parent().css('height',$('.js-hd-fix').outerHeight()+topbar+'px')
      } else {
        $('.js-hd-fix').parent().css('height','')
      }
    })
    $(document).on('scroll',function(){
      if ($(document).scrollTop() > start) {
        $('.js-hd-fix').addClass('hd-fixed')
        if ($('.js-hd-fix').hasClass('style4')) {
          $('.vertical').addClass('active2')
        }
      } else {
        $('.js-hd-fix').removeClass('hd-fixed')
        if ($('.js-hd-fix').hasClass('style4')) {
          $('.vertical').removeClass('active2')
        }
      }
    })
  }

  function resetPassForm() {
    $('.login-page .js-recover-click').on('click',function(){
      $('.login-page .js-customer').addClass('d-none')
      $('.login-page .js-recover').removeClass('d-none')
    })
    $('.login-page .js-hideRecover').on('click',function(){
      $('.login-page .js-customer').removeClass('d-none')
      $('.login-page .js-recover').addClass('d-none')
    })
    $('.customer-tab .js-recover-click').on('click',function(){
      $('.customer-tab .des').addClass('d-none')
      $('.customer-tab .js-customer-login').addClass('d-none')
      $('.customer-tab .js-recover').removeClass('d-none')
    })
    $('.customer-tab .js-hideRecover').on('click',function(){
      $('.customer-tab .des').removeClass('d-none')
      $('.customer-tab .js-customer-login').removeClass('d-none')
      $('.customer-tab .js-recover').addClass('d-none')
    })
  }

  function specialHd() {
    if ($('header.header').hasClass('style5')) {
      $('.product-detail').addClass('with-hdv5')
    }
  }

  function backToTop() {
    $('#back-to-top').on('click',function(){
      $('body,html').animate({scrollTop:0},300)
    })
  }

  function FilterPushLeft(){
    $('.js-filter').on('click',function(){
      $('.js-filter-canvas').toggleClass('active');
      $('.js-overlay-filter').addClass('active');    
    });
    $('.js-close-filter').on('click',function(){
      $('.js-filter-canvas').removeClass('active');
      $('.js-overlay-filter').removeClass('active'); 
    });
    $('.js-overlay-filter').on('click',function(){
      $('.js-filter-canvas').removeClass('active');
      $('.js-overlay-filter').removeClass('active'); 
    });


  }

  function slideSpecialEffect() {
    $(window).load(function(){
      setTimeout(function(){
        if ($('body').find('.slide-fix').length > 0) {
          $('#shopify-section-header .header').removeClass('.hd-absolute, .hd-absolute1, .hd-absolute2')
          var heightSlide = $('.slide-fix').height()
          var heightHeader = $('#shopify-section-header').height()
          if ($(window).width() < 1199) {
            heightHeader = $('.header-mobile').height()
            heightSlide = $('.slide-fix').height()+$('.header-mobile').height()
          }
          $('.slide-fix').css({'top':heightHeader})
          $('#shopify-section-header').css({'margin-bottom':heightSlide})
        }
      },300)
    })
    $(window).resize(function(){
      setTimeout(function(){
        if ($('body').find('.slide-fix').length > 0) {
          $('#shopify-section-header .header').removeClass('.hd-absolute, .hd-absolute1, .hd-absolute2')
          var heightSlide = $('.slide-fix').height()
          var heightHeader = $('#shopify-section-header').height()
          if ($(window).width() < 1199) {
            heightHeader = $('.header-mobile').height()
            heightSlide = $('.slide-fix').height()+$('.header-mobile').height()
          }
          $('.slide-fix').css({'top':heightHeader})
          $('#shopify-section-header').css({'margin-bottom':heightSlide})
        }
      },300)
    })
  }

  function menuDesktopScrollProduct() {
    var $nav = $(".js-header");
    $nav.removeClass('menu-scroll-product');

    $(document).scroll(function() {

      $nav.toggleClass('menu-scroll-product', $(this).scrollTop() > $nav.height());
    });
  }


  function openHeaderIcon() {
    $('.js-open-login-popup, .js-open-mini-cart, .js-open-search').each(function(){
      $(this).on('click',function(){
        if ($('.element-icon').attr('data-open') == 'true') {
          if ($(this).hasClass('active')) {
            $('.element-icon').removeClass('active')
            $('.element-icon').attr('data-open','false')
            $('.element-icon').find('.btn-icon .active').removeClass('active')
            setTimeout(function(){
              $('.element-icon').find('.content-popup .active').removeClass('active')
            },300)
          } else {
            $('.element-icon').find('.active').removeClass('active')
            $(this).addClass('active')
            $('#'+$(this).attr('data-click')).addClass('active')
          }
        } else {
          $('.element-icon').addClass('active')
          $('.element-icon').attr('data-open','true')
          $(this).addClass('active')
          $('#'+$(this).attr('data-click')).addClass('active')
        }
      })
    })
    $('.content-popup .js-toggle').each(function(){
      $(this).on('click',function(){
        $('.content-popup .content').children('.active1').removeClass('active1');
        $('#'+$(this).attr('data-toggle')).addClass('active1')
      })
    })
    $('.element-icon .bg-icon').on('click',function(){
      $('.element-icon').find('.btn-icon .active').click()
    })
    $('.js-close-cart-popup').on('click',function(){
      $('.js-open-mini-cart').click()
    })
  }

  function clickVariantImg() {
    var img
    $('.product-item-v2').each(function(){
      var  $product = $(this)
      $product.find('.var-image').each(function(){
        $(this).on('click',function(){
          img = $(this).attr('data-engojvariant-img')
          $product.find('.img-hover').attr('src',img)
        })
      })
    })
  }

  productDetailSlide();
  productDetailSlideBT();
  productDetailSingleSlide();
  relatedSlick();
  btnSidebar();
  productCollectionSlide();
  ESC();
  openHeaderIcon();
  blogCarousel();
  productCarousel();
  slideSpecialEffect();
  productCollection();
  testimonialAndBlog();
  testimonialV1();
  testimonialV2();
  categoryV2();
  slideShowV1();
  verticalMenu();
  slideShowV3();
  slideShowV2();
  slideShowV4();
  bannerSlide();
  slideshowBanner();
  menuMobile();
  resetPassForm();
  $(window).load(function(){
    hdFixed();
  })
  specialHd();
  backToTop();
  FilterPushLeft();
  menuDesktopScrollProduct();
  clickTab();
  clickVariantImg();
})